<template>
  <UserProperty
    @dataAvailable="
      data => {
        userData = data || {}
      }
    "
  />

  <DataGetter
    @dataAvailable="
      data => {
        subscription = data?.metaData || {}
      }
    "
    contentId="subscription"
  />

  <div class="h-full overflow-auto w-full flex-col flex">
    <div class="min-h-[11rem]">
      <div class="flex w-full justify-between items-center px-8 pt-8">
        <div class="text-4xl text-gray-800 font-bold">Préférences</div>
      </div>
      <div class="py-4"></div>
      <div class="px-8">
        <div class="flex flex-col md:flex-row gap-2 justify-between">
          <div class="p-1 bg-white rounded-2xl w-full md:w-auto overflow-auto">
            <div
              class="flex gap-4 w-full md:w-auto items-center whitespace-nowrap min-w-max"
            >
              <button
                class="px-4 py-2 rounded-xl flex items-center justify-center relative overflow-hidden"
                v-for="(tab, i) in tabs"
                :key="i"
                @click="switchTab(tab.id)"
              >
                <div
                  :class="{
                    'w-full h-full bg-blue-500': activeTab == tab.id,
                    'w-full h-full bg-slate-100': activeTab !== tab.id,
                  }"
                  class="duration-300 absolute rounded-xl"
                ></div>
                <div
                  class="relative"
                  :class="{
                    'text-white': activeTab == tab.id,
                    'text-gray-600': activeTab !== tab.id,
                  }"
                >
                  {{ tab.name }}
                </div>
              </button>
            </div>
          </div>
          <div class="flex gap-2" v-if="saveButtonIsVisible">
            <button
              class="buttonComponent bg-gray-100 text-gray-600 hover:bg-gray-200"
              @click="cancelChanges"
            >
              Annuler
            </button>
            <button class="buttonComponent" @click="saveChanges">
              Enregistrer
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full h-full overflow-hidden">
      <!-- Onglet Profil -->
      <div class="w-full h-full" v-if="activeTab == 'profile'">
        <div class="py-[0.5rem]"></div>
        <div class="pl-[2rem] relative z-[2] pointer-events-none">
          <div
            class="w-[8rem] h-[8rem] overflow-hidden rounded-full border-4 border-white shadow-lg bg-white"
          >
            <img
              :src="storeData.logo || '/logo.png'"
              class="w-full h-full object-cover"
              alt=""
            />
          </div>
        </div>
        <div
          class="w-full h-[calc(100%-3rem)] bg-white relative -mt-[6rem] overflow-auto"
        >
          <div class="w-full pl-[11rem] pt-4 h-[6rem]">
            <div class="text-gray-800 text-xl font-bold">
              {{ userData?.firstName }}
              {{ userData?.lastName }}
            </div>
            <div class="text-gray-500">{{ userData?.email }}</div>
          </div>
          <div class="py-2"></div>
          <div class="px-8">
            <div class="flex justify-between border-b pb-4">
              <div class="flex flex-col">
                <div class="font-bold text-lg text-gray-800">
                  Profil de l'entreprise
                </div>
                <div class="text-gray-500">
                  Mettez à jour la photo et les détails de votre entreprise ici
                </div>
              </div>
            </div>
            <div class="flex flex-col md:flex-row gap-8 border-b pb-4 pt-4">
              <div class="w-[30rem] max-w-full">
                <div class="font-bold text-lg text-gray-800">
                  Nom de l'entreprise
                </div>
                <div class="text-gray-500">
                  Ceci sera affiché dans storeprofil
                </div>
              </div>
              <div class="w-[30rem] max-w-full">
                <div class="">
                  <InputComponent
                    v-model="storeData.storeName"
                    label="Nom de Store"
                  />
                  <div class="py-2"></div>
                  <div class="flex items-center relative">
                    <InputComponent
                      v-model="storeData.publicStoreId"
                      class="[&_input]:!pl-[28ch] [&_label]:!pl-[27ch] [&_input:focus_~_label]:!pl-[0px] [&_input:not(.empty)_~_label]:!pl-[0px]"
                      label="Id de store"
                    />
                    <div class="-mt-1 mx-1 absolute">
                      <div
                        class="inputContainer !w-min px-2 flex items-center !rounded-none !border-y-transparent !bg-transparent !border-l-transparent"
                      >
                        https://ekidiscount.com/store/
                      </div>
                    </div>
                    <div
                      class="absolute w-10 h-10 flex items-center justify-center left-full ml-2 -mt-1"
                    >
                      <Loader
                        class="scale-[0.6]"
                        title="Vérification de la disponibilité"
                        v-if="newStoreIdDetails.checkingAvailability"
                      />
                      <img
                        src="@/assets/images/all/alerte.svg"
                        class="w-full h-full !pointer-events-auto"
                        title="Cet identifiant est déjà utilisé"
                        v-else-if="!newStoreIdDetails.isAvailable"
                      />
                      <img
                        src="@/assets/images/all/check-normal-primary.svg"
                        class="w-full h-full !pointer-events-auto"
                        title="Cet identifiant est disponible"
                        v-else-if="newStoreIdDetails.gotUpdate"
                      />
                      <img
                        class="w-2/3 h-2/3 cursor-pointer !pointer-events-auto ripple"
                        v-else
                        @click="copyStoreUrl"
                        src="@/assets/images/all/copy.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col md:flex-row gap-8 border-b pb-4 pt-4 relative"
            >
              <div class="w-[30rem] max-w-full">
                <div class="font-bold text-lg text-gray-800">
                  Logo de l'entreprise
                </div>
                <div class="text-gray-500">
                  Mettez à jour la photo de la store
                </div>
              </div>
              <div class="w-[30rem] max-w-full h-full">
                <div class="flex items-start gap-8 w-full">
                  <div
                    class="w-[8rem] min-w-[8rem] h-[8rem] overflow-hidden rounded-full border-4 border-white shadow-lg bg-white"
                  >
                    <img
                      :src="storeData.logo || '/logo.png'"
                      class="w-full h-full object-cover"
                      alt=""
                    />
                  </div>

                  <div class="h-full w-full">
                    <FileUploader
                      :acceptedFilesTypes="['image/png', 'image/jpeg']"
                      @onFileChanged="
                        (id, name, url) => newFileSelected(id, name, url)
                      "
                      :key="filePikerKey"
                    >
                      <div
                        class="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 rounded-[1.5rem] bg-gray-50"
                      >
                        <svg
                          class="w-8 h-8 text-gray-400 mb-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                          ></path>
                        </svg>
                        <p class="text-gray-600 text-sm text-center">
                          Cliquez pour téléverser ou glisser-déposer
                        </p>
                        <p class="text-gray-400 text-xs mt-1">Png, Jpg, ..</p>
                      </div>
                    </FileUploader>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col md:flex-row gap-8 border-b pb-4 pt-4 relative"
            >
              <div class="w-[30rem] max-w-full">
                <div class="font-bold text-lg text-gray-800">
                  Couleur de la Store
                </div>
                <div class="text-gray-500">
                  Définissez la couleur de votre store ici
                </div>
              </div>
              <div class="w-[30rem] max-w-full h-full">
                <div class="mt-4 relative">
                  <div class="w-full overflow-auto">
                    <div class="flex min-w-max flex-wrap gap-2">
                      <div
                        class="relative min-w-8 w-8 h-8 p-1 rounded-full cursor-pointer group border"
                        :style="{ backgroundColor: color }"
                        v-for="(color, i) in availableColors"
                        :key="i"
                        @click="storeData.mainColor = color"
                      >
                        <img
                          :class="{
                            'opacity-0 ': color !== storeData.mainColor,
                          }"
                          class="w-full h-full duration-200"
                          src="@/assets/images/all/check-normal-white.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>

                  <div class="py-2"></div>

                  <!-- <input
                    type="color"
                    ref="colorPicker"
                    class="absolute opacity-0"
                    v-model="storeData.mainColor"
                  />
                  <button
                    tabindex="1"
                    @click="$refs.colorPicker.click()"
                    class="bg-primary-100 border-2 border-primary px-4 py-2 rounded-2xl inline-block"
                  >
                    Sélectionner une couleur
                  </button> -->
                </div>
              </div>
            </div>
            <div class="flex flex-col md:flex-row gap-8 border-b pb-4 pt-4">
              <div class="w-[30rem] max-w-full">
                <div class="font-bold text-lg text-gray-800">
                  Réseaux sociaux
                </div>
                <div class="text-gray-500">
                  Ajoutez vos liens de réseaux sociaux.
                </div>
              </div>
              <div class="w-[30rem] max-w-full">
                <div class="">
                  {{ this.storeData.facebookLink }}
                  <div class="flex items-center">
                    <InputComponent
                      class="[&_input]:!pl-[21ch] [&_label]:!pl-[20ch] [&_input:focus_~_label]:!pl-[0px] [&_input:not(.empty)_~_label]:!pl-[0px]"
                      label="Facebook"
                      v-model="storeData.facebookPageId"
                    />
                    <div class="-mt-1 mx-1 absolute w-[6rem]">
                      <div
                        class="inputContainer !w-min px-2 flex items-center !rounded-none !border-y-transparent !bg-transparent !border-l-transparent"
                      >
                        https://facebook.com/
                      </div>
                    </div>
                  </div>
                  <div class="py-2"></div>
                  <div class="flex items-center">
                    <InputComponent
                      class="[&_input]:!pl-[22ch] [&_label]:!pl-[21ch] [&_input:focus_~_label]:!pl-[0px] [&_input:not(.empty)_~_label]:!pl-[0px]"
                      label="Instagram"
                      v-model="storeData.instagramPageId"
                    />
                    <div class="-mt-1 mx-1 absolute w-[6rem]">
                      <div
                        class="inputContainer !w-min px-2 flex items-center !rounded-none !border-y-transparent !bg-transparent !border-l-transparent"
                      >
                        https://instagram.com/
                      </div>
                    </div>
                  </div>
                  <div class="py-2"></div>
                </div>
              </div>
            </div>
            <div class="py-12"></div>
          </div>
        </div>
      </div>

      <!-- Onglet Paiements & Boutique -->
      <div class="w-full h-full" v-if="activeTab == 'paymentStore'">
        <div class="py-[0.5rem]"></div>
        <div
          class="w-full h-[calc(100%-3rem)] bg-white relative mt-[2rem] overflow-auto"
        >
          <div class="py-2"></div>
          <div class="px-8 xl:w-3/4">
            <div class="py-4"></div>
            <div class="text-4xl font-semibold text-gray-900 mb-6">
              Paiements & Boutique
            </div>

            <div class="flex flex-col md:flex-row gap-8 border-b pb-4 pt-4">
              <div class="w-[30rem] max-w-full">
                <div class="font-bold text-lg text-gray-800">
                  Nom de l'entreprise
                </div>
                <div class="text-gray-500">
                  Ceci sera affiché dans storeprofil
                </div>
              </div>
              <!-- <div class="w-[30rem] max-w-full">
                <div class="">
                  <InputComponent
                    type="select"
                    :options="['XOF', 'NGN', 'USD', 'EUR']"
                    v-model="storeData.currency"
                    label="Devise des produits"
                  />
                </div>
              </div> -->
            </div>

            <div class="py-4"></div>
            <div class="text-2xl font-semibold text-gray-900 mb-6">
              Méthodes de paiement
            </div>

            <div class="space-y-6">
              <label
                for="storeData.mobileMoneyPaymentEnabled"
                class="flex items-center justify-between cursor-pointer"
              >
                <div>
                  <div class="text-lg font-semibold text-gray-800 mb-2">
                    Paiements par mobile money
                  </div>
                  <div class="text-gray-600 mb-4">
                    Autoriser les paiements par mobile money
                  </div>
                </div>
                <label class="switch pointer-events-none">
                  <input
                    type="checkbox"
                    v-model="storeData.mobileMoneyPaymentEnabled"
                    id="storeData.mobileMoneyPaymentEnabled"
                    @change="handleChange"
                  />
                  <span class="slider round"></span>
                </label>
              </label>
              <div>
                <label
                  class="flex items-center justify-between cursor-pointer"
                  for="storeData.cardPaymentEnabled"
                >
                  <div>
                    <div class="text-lg font-semibold text-gray-800 mb-2">
                      Cartes Bancaires
                    </div>
                    <div class="text-gray-600 mb-4">
                      Autoriser les paiements par carte bancaire
                    </div>
                  </div>
                  <label class="switch pointer-events-none">
                    <input
                      type="checkbox"
                      v-model="storeData.cardPaymentEnabled"
                      id="storeData.cardPaymentEnabled"
                      @change="handleChange"
                    />
                    <span class="slider round"></span>
                  </label>
                </label>
              </div>
            </div>

            <div class="mt-4">
              <div class="text-2xl font-semibold text-gray-900 mb-6">
                Nom de domaine
              </div>

              <div class="mb-6" @click="tryAlertProRequired">
                <label
                  :class="{ 'pointer-events-none': !subscription.isActive }"
                  for="storeData.useCustomDomain"
                  class="flex justify-between"
                >
                  <div>
                    <div class="text-lg font-semibold text-gray-800 mb-2">
                      Nom de domaine personnalisé
                    </div>
                    <div class="text-gray-600 mb-4">
                      Utiliser un nom de domaine personnalisé pour mon
                      entreprise
                    </div>
                  </div>
                  <label class="switch pointer-events-none">
                    <input
                      id="storeData.useCustomDomain"
                      type="checkbox"
                      v-model="storeData.useCustomDomain"
                      @change="handleChange"
                    />
                    <span class="slider round"></span>
                  </label>
                </label>
              </div>

              <div class="mb-6" @click="tryAlertProRequired">
                <div :class="{ 'pointer-events-none': !subscription.isActive }">
                  <div>
                    <div class="text-lg font-semibold text-gray-800 mb-2">
                      Nom de domaine à utiliser
                    </div>
                  </div>
                  <div class="relative w-min flex items-center">
                    <InputComponent
                      class="border rounded-lg px-4 py-2 !w-[30rem] max-w-full"
                      v-model="storeData.customDomainName"
                      :class="{ '!bg-gray-200': !storeData.useCustomDomain }"
                      :placeHolder="
                        storeData.useCustomDomain ? 'https://exemple.com' : ''
                      "
                      :disabled="!storeData.useCustomDomain"
                      @input="handleChange"
                    />

                    <!-- {{dnsZoneCorrectlyConfigured}}
                  {{domainNameInstalled}}
                  {{detectedHostingProvider}} -->
                    <div
                      class="absolute w-10 h-10 flex items-center justify-center left-full ml-2 -mt-1"
                      v-if="
                        storeData.useCustomDomain && storeData.customDomainName
                      "
                    >
                      <Loader
                        class="scale-[0.6]"
                        title="Vérification de la disponibilité"
                        v-if="domainRefreshing"
                      />
                      <img
                        src="@/assets/images/all/alerte.svg"
                        class="w-full h-full !pointer-events-auto"
                        title="Configuration non terminée"
                        v-else-if="!domainNameInstalled || !domainNameInstalled"
                      />
                      <img
                        src="@/assets/images/all/check-normal-primary.svg"
                        class="w-full h-full !pointer-events-auto"
                        title="Nom de domaine configuré"
                        v-else
                      />
                      <!-- <img
                        class="w-2/3 h-2/3 cursor-pointer !pointer-events-auto ripple"
                        v-else
                        @click="copyStoreUrl"
                        src="@/assets/images/all/copy.svg"
                        alt=""
                      /> -->
                    </div>
                  </div>
                  <div
                    v-if="
                      storeData.useCustomDomain &&
                      storeData.customDomainName &&
                      !domainNameInstalled
                    "
                    class="relative inline-block"
                  >
                    <VDropdown
                      :distance="6"
                      theme="tooltip-light-large"
                      placement="top"
                      :triggers="['hover', 'click']"
                      :popperTriggers="['hover']"
                    >
                      <div class="text-red-500 -mt-6 font-bold cursor-pointer">
                        Liez votre nom de domaine à nos serveurs
                        <span>
                          <img
                            class="inline-block w-5 h-5"
                            src="@/assets/images/all/information.svg"
                          />
                        </span>
                      </div>
                      <template #popper>
                        <div class="text-start p-6 text-base w-[35rem]">
                          <CustomDomainInstructions
                            :domainName="storeData.customDomainName"
                          />
                        </div>
                      </template>
                    </VDropdown>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-8">
              <div class="text-2xl font-semibold text-gray-900 mb-6">
                Livraison
              </div>

              <div class="flex justify-between">
                <div>
                  <div class="text-lg font-semibold text-gray-800 mb-2">
                    Comment gérer les livraisons
                  </div>
                  <div class="text-gray-600 mb-4">
                    Sélectionnez comment vos produits seront livrés aux clients
                  </div>
                </div>
                <div>
                  <DropdownComponent
                    :selects="[
                      {
                        name: 'Géré par le propriétaire de la Store',
                        onClicked() {},
                      },
                      {
                        name: 'Géré par Gozem',
                        onClicked() {
                          $Events.dispatchEvent('toast_notification', {
                            title: 'Bientot disponible',
                            body: 'Cette option sera bientot disponible dans votre région',
                          })
                        },
                      },
                      {
                        name: 'Géré par Coursier',
                        onClicked() {
                          $Events.dispatchEvent('toast_notification', {
                            title: 'Bientot disponible',
                            body: 'Cette option sera bientot disponible dans votre région',
                          })
                        },
                      },
                    ]"
                    maxHeight="270px"
                    displayKey="name"
                    toRight
                    :onSelect="
                      option => {
                        option.onClicked()
                      }
                    "
                    class="border px-4 py-2 rounded-xl bg-gray-100"
                  >
                    Géré par le propriétaire de la Store
                  </DropdownComponent>
                </div>
              </div>
              <div></div>
            </div>
            <div class="py-12"></div>
          </div>
        </div>
      </div>

      <!-- Onglet Notifications -->
      <div class="w-full h-full" v-if="activeTab == 'notification'">
        <div class="py-[0.5rem]"></div>
        <div
          class="w-full h-[calc(100%-3rem)] bg-white relative mt-[2rem] overflow-auto"
        >
          <div class="py-2"></div>
          <div class="px-8 xl:w-3/4">
            <div class="py-4"></div>
            <div class="text-2xl font-semibold text-gray-900 mb-6">
              Mes notifications
            </div>

            <div class="mb-8">
              <div class="text-lg font-semibold text-gray-800 mb-4">
                Me notifier lorsque...
              </div>
              <div class="space-y-3 pl-4">
                <label
                  class="flex items-center justify-between cursor-pointer"
                  for="storeData.notifyStoreOnPaymentDone"
                >
                  <div class="text-gray-700">Le client a payé un produit</div>
                  <label class="switch pointer-events-none">
                    <input
                      type="checkbox"
                      v-model="storeData.notifyStoreOnPaymentDone"
                      id="storeData.notifyStoreOnPaymentDone"
                      @change="handleChange"
                    />
                    <span class="slider round"></span>
                  </label>
                </label>

                <!-- Ligne 2 -->
                <label
                  class="flex items-center justify-between cursor-pointer"
                  for="storeData.notifyStoreOnBalanceUpdated"
                >
                  <div class="text-gray-700">
                    Le solde de ma boutique change
                  </div>
                  <label class="switch pointer-events-none">
                    <input
                      type="checkbox"
                      v-model="storeData.notifyStoreOnBalanceUpdated"
                      id="storeData.notifyStoreOnBalanceUpdated"
                      @change="handleChange"
                    />
                    <span class="slider round"></span>
                  </label>
                </label>

                <!-- Ligne 3 -->
                <label
                  class="flex items-center justify-between cursor-pointer"
                  for="storeData.notifyStoreOnOrderDelivered"
                >
                  <div class="text-gray-700">Une commande est livrée</div>
                  <label class="switch pointer-events-none">
                    <input
                      type="checkbox"
                      v-model="storeData.notifyStoreOnOrderDelivered"
                      id="storeData.notifyStoreOnOrderDelivered"
                      @change="handleChange"
                    />
                    <span class="slider round"></span>
                  </label>
                </label>
              </div>
            </div>

            <div class="py-4"></div>
            <div class="text-2xl font-semibold text-gray-900 mb-6">
              Notification du clients
            </div>

            <div class="mb-8">
              <div class="text-lg font-semibold text-gray-800 mb-4">
                Notifier le client lorsque...
              </div>
              <div class="space-y-3 pl-4">
                <label
                  class="flex items-center justify-between cursor-pointer"
                  for="storeData.notifyCustomerOnPaymentDone"
                >
                  <div class="text-gray-700">Paiement effectué</div>
                  <label class="switch pointer-events-none">
                    <input
                      type="checkbox"
                      v-model="storeData.notifyCustomerOnPaymentDone"
                      id="storeData.notifyCustomerOnPaymentDone"
                      @change="handleChange"
                    />
                    <span class="slider round"></span>
                  </label>
                </label>
                <label
                  class="flex items-center justify-between cursor-pointer"
                  for="storeData.notifyCustomerOnOrderDelivered"
                >
                  <div class="text-gray-700">Livraison reçue</div>
                  <label class="switch pointer-events-none">
                    <input
                      type="checkbox"
                      v-model="storeData.notifyCustomerOnOrderDelivered"
                      id="storeData.notifyCustomerOnOrderDelivered"
                      @change="handleChange"
                    />
                    <span class="slider round"></span>
                  </label>
                </label>
              </div>
            </div>
            <div class="py-12"></div>
          </div>
        </div>
      </div>

      <!-- Onglet Notifications -->
      <div class="w-full h-full" v-if="activeTab == 'userProfile'">
        <div class="py-[0.5rem]"></div>
        <div
          class="w-full h-[calc(100%-3rem)] bg-white relative mt-[2rem] overflow-auto"
        >
          <div class="py-2"></div>
          <div class="px-8 md:w-3/4">
            <div class="py-4"></div>
            <div
              class="text-2xl font-semibold text-gray-900 mb-6 flex flex-col"
            >
              Mes informations Personnelles
            </div>
            <div class="py-1"></div>
            <InputComponent
              disabled
              label="Nom & Prénom"
              :value="`${userData.firstName} ${userData.lastName !== 'none' ? userData.lastName : ''}`"
            />
            <div class="py-1"></div>
            <InputComponent disabled label="Email" v-model="userData.email" />
            <div class="py-1"></div>
            <button class="underline text-primary" @click="editPassword">
              Modifier mon mot de passe
            </button>

            <div class="py-12"></div>
          </div>
        </div>
      </div>
    </div>
    <EventListener
      :events="['failed_to_save_store_data', 'store_data_saved']"
      @failed_to_save_store_data="onStoreDataNotSaved"
      @store_data_saved="onStoreDataSaved"
    />
  </div>
</template>

<script>
import UserProperty from '@/components/user/UserProperty.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import FileUploader from '@/components/utils/FileUploader.vue'
import InputComponent from '@/components/utils/InputComponent.vue'
import Loader from '@/components/utils/Loader.vue'
import CustomDomainInstructions from './CustomDomainInstructions.vue'

export default {
  name: 'homeComponent',
  components: {
    UserProperty,
    InputComponent,
    FileUploader,
    DropdownComponent,
    EventListener,
    Loader,
    DataGetter,
    CustomDomainInstructions,
  },
  data() {
    return {
      userData: {},
      tabs: {
        profile: { id: 'profile', name: 'Entreprise' },
        paymentStore: { id: 'paymentStore', name: 'Paiements & Boutique' },
        notification: { id: 'notification', name: 'Notifications' },
        userProfile: { id: 'userProfile', name: 'Mon Compte' },
        // withdrawal: { id: 'withdrawal', name: 'Reversements' },
      },
      activeTab: this.$route.hash == '#personnal' ? 'userProfile' : 'profile',
      saveButtonIsVisible: false,
      dataLoaded: false,
      storeData: {},
      subscription: {},
      defaultData: {},
      filePikerKey: 'none',
      newStoreIdDetails: {
        isAvailable: true,
        checkingAvailability: false,
        gotUpdate: false,
      },
      availableColors: [
        '#FD2270',
        '#42CEFF',
        '#1B41BC',
        '#FF5733',
        '#228B22',
        '#FFD700',
        '#8A2BE2',
        '#FF69B4',
        '#2F4F4F',
        '#000000',
      ],
      domainNameRefreshInterval: 0,
      dnsZoneCorrectlyConfigured: false,
      domainNameInstalled: false,
      domainRefreshing: true,
      detectedHostingProvider: '',
      activeInstructionsHostingProvider: '',
    }
  },
  mounted() {
    this.loadStoreData()
    this.initCustomDomainNameRefresh()
  },
  beforeUnmount() {
    clearInterval(this.domainNameRefreshInterval)
  },
  methods: {
    initCustomDomainNameRefresh() {
      clearInterval(this.domainNameRefreshInterval)
      if (!this.storeData.useCustomDomain || !this.storeData.customDomainName)
        return
      this.domainNameRefreshInterval = setInterval(
        this.refreshCustomDomainNameInstallation,
        5000,
      )
    },
    async refreshCustomDomainNameInstallation() {
      this.domainRefreshing = true
      const res = await this.$Events.sendDataRequestResolve(
        'domainNameInstallation',
        { domain: this.storeData.customDomainName },
      )
      this.domainRefreshing = false
      console.log(res)
      if (res?.statusCode !== 200) return
      const {
        domainNameInstalled,
        dnsZoneCorrectlyConfigured,
        detectedHostingProvider,
      } = res.data
      this.dnsZoneCorrectlyConfigured = dnsZoneCorrectlyConfigured
      this.domainNameInstalled = domainNameInstalled
      this.detectedHostingProvider = detectedHostingProvider
      if (dnsZoneCorrectlyConfigured && !domainNameInstalled)
        this.installDomainName()
      if (dnsZoneCorrectlyConfigured && domainNameInstalled) {
        clearInterval(this.domainNameRefreshInterval)
      }
    },
    async installDomainName() {
      this.domainRefreshing = true
      clearInterval(this.domainNameRefreshInterval)
      await this.$Events.sendDataRequestResolve('installDomainName', {
        domain: this.storeData.customDomainName,
      })
      this.domainRefreshing = false
      this.initCustomDomainNameRefresh()
    },
    editPassword() {
      this.$Events.dispatchEvent('password_reset_required', {
        email: this.userData?.email,
        userName: this.userData?.firstName,
      })
    },
    newFileSelected(id, name, url) {
      this.saveButtonIsVisible = true
      this.storeData.logo = url
      this.filePikerKey = `${Date.now()}`
    },
    onAppDataUpdated() {
      setTimeout(() => {
        if (this.saveButtonIsVisible) return
        this.loadStoreData()
      }, 500)
    },
    async loadStoreData() {
      this.dataLoaded = false
      this.saveButtonIsVisible = false
      this.newStoreIdDetails.gotUpdate = false
      const res = await this.$Events.sendDataRequestResolve('storeData')
      if (!res) return
      this.storeData = res.metaData
      this.initCustomDomainNameRefresh()
      setTimeout(() => {
        this.dataLoaded = true
        this.saveButtonIsVisible = false
        this.newStoreIdDetails.gotUpdate = false
      })
      setTimeout(() => {
        this.dataLoaded = true
        this.saveButtonIsVisible = false
        this.newStoreIdDetails.gotUpdate = false
      }, 500)
    },
    async switchTab(tabId) {
      if (this.saveButtonIsVisible) {
        const prompt = await window.customPrompt({
          title:
            'Vous avez des modifications non enregistrées. Voulez-vous continuer ?',
          formFields: [],
          successText: 'Annuler les modifications',
        })
        if (!prompt.accepted) return
        this.cancelChanges()
      }
      this.activeTab = tabId
    },
    cancelChanges() {
      this.loadStoreData()
    },
    saveChanges() {
      const allDataAreValid = this.checkStoreData()
      if (!allDataAreValid) return false
      this.$Events.dispatchEvent('start_loading', {
        title: 'Enrégistrement en cours',
      })
      this.$Events.dispatchEvent('store_preferences_setted', this.storeData)
    },
    checkStoreData() {
      if (!this.storeData.publicStoreId) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Id de store requis',
          body: 'Veuillez entrer une id de store unique pour continuer',
        })
        return false
      }
      if (!this.newStoreIdDetails.isAvailable) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Id de store déjà utilisé',
          body: 'Veuillez entrer une id de store disponible pour continuer',
        })
        return false
      }
      return true
    },
    onStoreDataNotSaved() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Échoué',
        body: "Nous rencontrons des problèmes lors de l'enrégistrement, veuillez réessayer",
      })
    },
    async onStoreDataSaved() {
      await new Promise(r => setTimeout(r, 1000))
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Réussi',
        body: 'Les informations ont été renrégistrées correctement.',
      })
      this.saveButtonIsVisible = false
      this.newStoreIdDetails.gotUpdate = false
      this.loadStoreData()
    },
    copyStoreUrl() {
      const url = `https://ekidiscount.com/store/${this.storeData.publicStoreId}`
      this.$Commons.copy(url, 'Lien de votre store copié')
    },
    copyDomainName() {
      this.$Commons.copy(`apis.ecoxurf.com`, 'Copié avec succès')
    },
    copyDomainHost() {
      this.$Commons.copy(`www`, 'Copié avec succès')
    },
    tryAlertProRequired() {
      if (this.subscription.isActive) return
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Fonctionnalité Ekidiscount Pro',
        body: 'Veuillez activer Ekidiscount pro pour accéder à cette fonctionnalité',
      })
    },
  },
  watch: {
    storeData: {
      deep: true,
      handler() {
        if (!this.dataLoaded) return
        this.saveButtonIsVisible = true
      },
    },
    ['storeData.facebookPageId'](newVal) {
      if (!this.dataLoaded) return
      if (/^https:\/\/(.+?)?facebook.com\//.test(newVal)) {
        this.storeData.facebookPageId = newVal.replace(
          /^https:\/\/(.+?)?facebook.com\//,
          '',
        )
        return
      }
      this.storeData.facebookLink = `https://facebook.com/${newVal}`
    },
    ['storeData.instagramPageId'](newVal) {
      if (!this.dataLoaded) return
      if (/^https:\/\/(.+?)?instagram.com\//.test(newVal)) {
        this.storeData.instagramPageId = newVal.replace(
          /^https:\/\/(.+?)?instagram.com\//,
          '',
        )
        return
      }
      this.storeData.instagramLink = `https://instagram.com/${newVal}`
    },
    async ['storeData.publicStoreId'](newVal) {
      if (!this.dataLoaded) return
      this.newStoreIdDetails.gotUpdate = true
      this.newStoreIdDetails.checkingAvailability = true
      this.newStoreIdDetails.isAvailable = false
      const details = await this.$Events.sendDataRequestResolve(
        'storeDetails',
        {
          storeId: newVal,
        },
      )
      if (newVal !== this.storeData.publicStoreId) return
      console.log(details?.metaData?.id, this.storeData.id)
      if (
        !details?.metaData?.id ||
        details?.metaData?.id == this.storeData.id
      ) {
        this.newStoreIdDetails.isAvailable = true
      } else this.newStoreIdDetails.isAvailable = false
      this.newStoreIdDetails.checkingAvailability = false
    },
  },
}
</script>

<style>
/* Style pour les toggles (switch) */
.switch {
  position: relative;
  display: inline-block;
  min-width: 5rem;
  width: 5rem;
  height: 3rem;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 3rem;
}

.slider:before {
  position: absolute;
  content: '';
  height: 2rem;
  width: 2rem;
  left: 0.5rem;
  bottom: 0.5rem;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:checked + .slider:before {
  transform: translateX(2rem);
}

/* Style pour le bouton rond */
.slider.round {
  border-radius: 3rem;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
